// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3xXYG","itemTitle":"ClientEmergencyInfo_itemTitle__3mKAa","itemText":"ClientEmergencyInfo_itemText__fgQ_O"};